import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import * as React from "react";
import { cx } from "../internal/cx.js";

export const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(function RadioGroup({ className, orientation = "vertical", ...props }, ref) {
  return (
    <RadioGroupPrimitive.Root
      ref={ref}
      className={cx("cw-v2-radio-group", className)}
      orientation={orientation}
      {...props}
    />
  );
});
RadioGroup.displayName = "RadioGroup";

/**
 * Single radio item. Must be a child of `<RadioGroup>`; Radix coordinates
 * the selected value across siblings. Pair each item with a `<Label
 * htmlFor>` for the accessible name.
 */
export const Radio = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(function Radio({ className, ...props }, ref) {
  return (
    <RadioGroupPrimitive.Item ref={ref} className={cx("cw-v2-radio", className)} {...props}>
      <RadioGroupPrimitive.Indicator className="cw-v2-radio__indicator">
        <span className="cw-v2-radio__dot" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
Radio.displayName = "Radio";
